import React from 'react'

import { Box, Drawer, styled } from '@mui/material'

import config from '../../../config'
import useIsMobile from '../../../common/hooks/useIsMobile'
import { colors } from '../../../utils/colorUtils'

const StyledDrawer = styled(Drawer)(({ width }) => ({
  display: 'flex',
  height: '100%',
  overflow: 'auto',
  width,
  '& .MuiDrawer-paper': {
    backgroundColor: colors.awaOffWhite,
    flexDirection: 'row',
    height: `calc(100vh - ${config.mapAppBarHeight}px)`,
    top: `${config.mapAppBarHeight}px`,
    width: 'fit-content',
  },
}))

const ControlPanel = ({ children, drawerWidth, helpPanel, open }) => {
  const isMobile = useIsMobile()

  return (
    <StyledDrawer
      variant="persistent"
      width={isMobile ? 0 : drawerWidth}
      open={open || !isMobile}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      {children}
      {helpPanel}
    </StyledDrawer>
  )
}

const StyledDrawerOriginal = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    top: `${config.mapAppBarHeight}px`,
    zIndex: 1202,
    paddingTop: theme.spacing(1),
    backgroundColor: colors.awaOffWhite,
    width: config.controlDrawerWidth,
  },
}))

const ControlPanelOriginal = ({ children, helpPanel, open }) => {
  const isMobile = useIsMobile()

  return (
    <StyledDrawerOriginal
      variant="persistent"
      open={open || !isMobile}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <Box
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
        }}
      >
        {children}
      </Box>
      {helpPanel}
    </StyledDrawerOriginal>
  )
}

export {
  ControlPanel as default,
  ControlPanelOriginal
}

